import { Switch, Route, Redirect } from "react-router-dom";

import Layout from "./Layout/Layout";
import Geotolk from "./pages/Geotolk";
import React from "react";
import { AuthProvider, RequiredAuthProvider } from "@propelauth/react";


function App() {

  return (
    <Layout>
      <Switch>
        <AuthProvider authUrl={process.env.REACT_APP_AUTH_URL} >
        <RequiredAuthProvider authUrl={process.env.REACT_APP_AUTH_URL}>
          <Route path="/geotolk/:project_id/:srid">
            <Geotolk />
            {/* <Redirect to="/auth" /> */}
          </Route>
          </RequiredAuthProvider>
        </AuthProvider>
      </Switch>
    </Layout>
  );
}

export default App;
